// extracted by mini-css-extract-plugin
export default {"container":"_2w1AhE5nWAAGw_AfMunvMe","map":"p68dyHxVLdvz5zbhjsoIs","legend":"_2gjlmeEuWU5-QD1vMrQ6zt","title":"_5SoGnueSwXKW3vpsRQMVv"};